<template>

  <Admin style="background: #f2f2f2">
    <v-main>

      <v-dialog v-model="showTextDialog" max-width="800px">
        <v-card>
          <v-card-title class="headline">Extracted Text</v-card-title>
          <v-card-text style="max-height: 60vh; overflow: auto; white-space: pre-wrap;">
            {{ rawText }}
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn text @click="showTextDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

         <v-dialog v-model="showResponse" max-width="800px">
        <v-card>
          <v-card-title class="headline">View Response</v-card-title>
          <v-card-text style="max-height: 60vh; overflow: auto; white-space: pre-wrap;">
            {{ rawText}}
            {{jsonResult}}
            {{ service }}
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn text @click="showResponse = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-container>
        <v-card
          class="rounded-xl tw-min-h-80 "
          v-if="!isProductListLoading"
        >
          <v-card-text v-if="!selectedCompany.isDemo">
            <v-breadcrumbs :items="items">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                  :to="item.to"
                  :disabled="item.disabled"
                  :exact="true"
                >
                  {{ item.text }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
              
          <!-- A4 Portrait -->
    <v-container fluid class="pa-0 fill-height ">
      <v-row dense class="fill-height  ">
      <!-- ฝั่งซ้าย: อัพโหลด & พรีวิว -->
         <v-col cols="12" md="5" class="d-flex flex-column ">
         <v-card outlined class="upload-card pa-2 d-flex flex-column flex-grow-1 tw-bg-light-gray">
          <input
            ref="fileInput"
            type="file"
            accept="application/pdf"
            class="d-none"
            @change="onFileSelected"
          />
          <div
            v-if="!pdfUrl"
            class="upload-placeholder flex-grow-1 d-flex flex-column justify-center tw-cursor-pointer align-center"
            @click="triggerFileSelect"
          >
            <v-icon size="64">mdi-cloud-upload</v-icon>
            <p class="font-weight-bold ">{{ fileName || 'Click to Upload PDF' }}</p>
          </div>
           <v-responsive
            v-else class="pdf-full"
            >
            <iframe
              :src="pdfUrl + '#toolbar=0&navpanes=0&scrollbar=0'"
              frameborder="0"
              class="w-100 h-100"
            />
          </v-responsive>
        </v-card>
      </v-col>

      <!-- ฝั่งขวา: ปุ่มควบคุม & Prompt -->
      <v-col cols="12" md="7">
        <v-card outlined class="controls-card pa-6 d-flex flex-column">
          <!-- ปุ่มต่างๆ -->
          <v-row dense no-gutters class="pa-2">
               <v-col cols="auto" class="pa-0 ">
                <v-btn
                  class="btn-short"
                  color="green"
                  :disabled="!pdfUrl || !selectedModel || !prompt || isProcessing"
                  @click="processPdf"
                >
                  <template v-if="isProcessing">
                    <v-progress-circular indeterminate color="green" size="20" class="mr-2" />
                    Processing...
                  </template>
                  <template v-else>Process</template>
                </v-btn>
              </v-col>
              <v-col cols="auto"  class="pa-0 ml-2 ">
                <v-btn
                  class="btn-short"
                  color="red"
                  outlined
                  :disabled="!pdfUrl || isProcessing"
                  @click="clearAll"
                >
                  Clear
                </v-btn>
              </v-col>
              <v-col cols="auto"  class="pa-0 ml-2 ">
                <v-btn
                  class="btn-short"
                  color="blue"
                  outlined
                  :disabled="!rawText || isProcessing"
                  @click="showTextDialog = true"
                >
                  View Text
                </v-btn>
              </v-col>
              <v-col cols="auto"  class="pa-0 ml-2">
                <v-btn
                  class="btn-short"
                  color="amber"
                  outlined
                  :disabled="!jsonResult || isProcessing"
                  @click="showResponse = true"
                >
                  View Response
                </v-btn>
              </v-col>
            </v-row>

            <v-row dense no-gutters class="mt-4" align="center">
              <v-col cols="auto" class="pa-1">
                <v-radio-group v-model="selectedService" row>
                  <v-radio label="Google Vision (Image-based)" value="Google" />
                  <v-radio label="Python (Text-based)" value="SLD" />
                </v-radio-group>
              </v-col>
              <v-col cols="12" sm="6" class="pa-1 d-flex align-center">
                <v-select
                  v-model="selectedModel"
                  :items="models"
                  item-text="label"
                  item-value="value"
                  label="Models"
                  outlined
                  dense
                  class="mt-5"
                />
              </v-col>
            </v-row>

          <!-- Prompt Textarea -->
          <v-textarea
            v-model="prompt"
            label="Prompt here..."
            outlined
            rows="20"
            class="flex-grow-1 mt-4 "
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
          
          <div class="tw-ml-9 tw-mt-10 tw-text-lg ">
            <div class="d-flex align-center justify-space-between">
            <p class="tw-font-bold">JSON RESULT :</p>
          </div>
            <div class="tw-relative tw-mr-8 tw-w-a4-landscape tw-h-a4-landscape tw-border-2 tw-rounded-md tw-bg-light-gray overflow-auto" style="max-height:100%;">
              <!-- FIXED Clipboard Icon -->
              <div class="tw-absolute tw-top-2 tw-right-2 tw-z-10 border-2" >
                <v-icon
                  v-if="jsonResult"
                  class="tw-cursor-pointer mr-5 mt-2"
                  style="font-size: 20px;"
                  small
                  @click="copyToClipboard"
                  title="Copy JSON to clipboard"
                >
                  mdi-clipboard-outline
                </v-icon>
                <span
  v-if="showCopiedMsg"
  class="tw-absolute tw-top-2 tw-right-10 tw-mr-2 tw-text-green-600 tw-text-sm tw-font-medium tw-whitespace-nowrap tw-transition-opacity tw-duration-200"
>
  ✓ Copied
</span>

              </div>
            <pre v-if="jsonResult" class="tw-whitespace-pre-wrap tw-overflow-auto tw-max-h-[500px] tw-p-2 tw-mt-10">
              {{ formatJson(jsonResult) }}
              </pre>
              <p v-else class="tw-text-gray-500-500"></p>
            </div>
          </div>
          
          </v-card-text>
          <div
            v-else
            class="align-center justify-center"
            style="height: 200px; display: flex"
          >
            No Permission
          </div>
        </v-card>
        <v-card v-else class="rounded-xl tw-min-h-80 tw-p-7">
          <v-skeleton-loader
            type="list-item-two-line"
            style="width: 400px;"
          ></v-skeleton-loader>
          <v-skeleton-loader
            type="list-item-three-line"
            style="width: 400px;"
          ></v-skeleton-loader>
          <v-skeleton-loader
            type="list-item-three-line"
            style="width: 400px;"
          ></v-skeleton-loader>

            
        </v-card>

      </v-container>
    </v-main>
  </Admin>
</template>
<script>
import Admin from "../../components/admin/admin-main-template";
import { mapState } from "vuex";
import firebase from "firebase/app";
import "firebase/auth";
import { Icon } from "element-ui";
import "firebase/functions"

export default {
  name: "Board",
  components: {
    Admin,
  },
  computed: {
    ...mapState({
  }),
  },
 
  data: () => ({
    items: [
      {
        text: "ตั้งค่า",
        disabled: false,
        to: { name: "Company.Settings" },
      },
      {
        text: "ทดสอบเอกสาร",
        disabled: true,
      },
    ],
    models: [
        { label: 'GPT-4.1 mini', value: 'gpt-4.1-mini' },
        { label: 'o4-mini', value: 'o4-mini' },
        { label: 'o3', value: 'o3' },
        { label: 'GPT-4.1', value: 'gpt-4.1' },
        // { label: 'GPT-4.1 Nano',  value: 'gpt-4.1-nano' },
        { label: "GPT-4o", value: "gpt-4o" },
        { label: "GPT-4o mini", value: "gpt-4o-mini" },
      ],
    selectedModel: 'gpt-4.1-mini',
    prompt: '',
    fileName: '',
    pdfUrl: null,
    selectedService: 'Google',
    jsonResult: '',   
    isProcessed: false,
    isProductListLoading:false,
    rawText: '', 
    showTextDialog: false,
    isProcessing: false,
    selectedCompany:"",
    showResponse: false,
    service:'',
    showCopiedMsg: false,

  }),  

methods: {
  triggerFileSelect() {
      this.$refs.fileInput.click();
    },
    onFileSelected(e) {
      const file = e.target.files[0];
      if (!file) {
        this.fileName = '';
        this.pdfUrl = null;
        this.isProcessed = false; 
        return;
      }
      this.fileName = file.name;
      this.pdfUrl = URL.createObjectURL(file);
    },
 
  beforeDestroy() {
    // revoke the object URL to avoid memory leaks
    if (this.pdfUrl) URL.revokeObjectURL(this.pdfUrl);
  },

copyToClipboard() {
  try {
    const formattedJson = this.formatJson(this.jsonResult);
    navigator.clipboard.writeText(formattedJson);
    this.showCopiedMsg = true;

    // Auto-hide message after 2 seconds
    setTimeout(() => {
      this.showCopiedMsg = false;
    }, 5000);
  } catch (err) {
    console.error("Copy failed:", err);
    alert("Copy failed");
  }
},

  async processPdf() {
    if (!this.pdfUrl) return;
    this.jsonResult = '';
    this.rawText    = '';
    this.service    = '';
    this.isProcessed = true;
    this.isProcessing = true;

    // 1) อ่านไฟล์ .pdf
    const file = this.$refs.fileInput.files[0]
    const reader = new FileReader()
    reader.onload = async () => {
      try {
        // 2) แปลงเป็น Base64 string (ตัด prefix data:…;base64,)
        const base64 = reader.result.split(',')[1]

        // 3) เอา callable function ที่ชื่อว่า callTextPdfTest
        const callTextPdfTest = firebase.functions().httpsCallable("callTextPdfTest")

        // 4) ส่ง request
        //    payload ต้องเป็น object ธรรมดา ไม่ต้อง JSON.stringify เอง
        const { data } = await callTextPdfTest({
          pdfBuffer: base64,
          prompt: this.prompt,
          model: this.selectedModel,
          service: this.selectedService
        })

        // 5) ได้ผลลัพธ์กลับมาใน data.jsonResult
        this.jsonResult = data.jsonResult
        this.rawText    = data.rawText 
        this.service    = data.service 
      }
      catch(err) {
        console.error("Error calling function:", err)
      }
      finally {
        this.isProcessed = true
        this.isProcessing = false; 
      }
    }
    reader.readAsDataURL(file)
  },
  
    clearAll() {
      this.pdfUrl = null;
      this.fileName = '';
      this.selectedService = 'Google';
      this.isProcessed = false
      this.jsonResult=''
      this.rawText=''
      this.selectedModel= 'gpt-4.1-mini'
    },

    viewText() {
    },
    
    formatJson(raw) {
    try {
      // ถ้าเป็น string แบบ JSON → แปลงเป็น object → stringify กลับด้วย spacing 2 ช่อง
      return JSON.stringify(JSON.parse(raw), null, 2);
    } catch (e) {
      // ถ้า parse ไม่ได้ แสดง raw string
      return raw;
    }
  }
  },

};

</script>

<style lang="scss">
.row-detail {
  padding-left: 24px;
}
.auto-mail-time-box {
  display: inline-block;
  width: 100px;
  .v-text-field {
    fieldset {
      border-radius: 10px;
    }
    input[type="text"] {
      text-align: center;
    }
  }
  .v-text-field--outlined fieldset {
    top: 0;
    height: 50px;
  }
}
.upload-card {
  /* ให้ card ใช้ flex ทั้งแนวตั้งเต็มความสูงของ col */
  flex: 1 1 auto;
}

.pdf-full {
  /* container ของ iframe เก็บ flex-grow */
  flex: 1 1 auto;
  position: relative;
}

.pdf-full iframe {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  border: none;
}

</style>